import Vue from 'vue';
import Router from 'vue-router';

const Home=()=>import('../src/components/Home');
const Ticket=()=>import('../src/components/Ticket');

Vue.use(Router);

const router = new  Router({
    mode: 'history', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'open active',
    scrollBehavior: () => ({y: 0}),
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home,
        },
        {
            path: '/t/:tId/:id?',
            name: 'Ticket',
            props:true,
            component: Ticket,
        },
        
        // otherwise redirect to home
        {path: '*', redirect: '/'}
    ]
});

export default router
